<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'SESSION_TIMEOUT_WARNING' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="info-text">{{ getSessionExpiryMessage(remainingTime$ | async) }}</p>
  <div class="button-container">
    <ion-button (click)="onContinueSession()" color="tertiary">{{ 'CONTINUE_SESSION' | translate }}</ion-button>
    <ion-button (click)="onLogout()" color="danger">{{ 'LOGOUT' | translate }}</ion-button>
  </div>
</ion-content>